<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body" style="padding: 1rem">
          <div class="text-center mb-2">
            <h2 class="text-center">Welcome!</h2>
          </div>
          <div>
            <div class="row mb--1">
              <div class="col">
                <base-input label="Mobile Number">
                  <a-input-group compact>
                    <a-select
                      v-model="countryCode"
                      default-value="+63"
                      :style="{ width: windowWidth < 768 ? '30%' : '21%' }"
                    >
                      <a-select-option value="+63">+63</a-select-option>
                    </a-select>
                    <a-input
                      v-model="formData.user_account"
                      placeholder="9xxxxxxxxxx"
                      @change="clear"
                      @keypress.enter="login"
                      :style="{ width: windowWidth < 768 ? '70%' : '79%' }"
                    />
                  </a-input-group>

                  <!-- Validation messages -->
                  <div v-if="$v.formData.user_account.$dirty" class="text-danger mt-1">
                    <div class="error" v-if="!$v.formData.user_account.required">
                      Field is required
                    </div>
                    <div class="error" v-if="!validUserAccount">
                      {{ validUserAccountMessage }}
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row mt--3 mb-2">
              <div class="col">
                <base-input label="Password">
                  <a-input-password
                    placeholder="Enter Password"
                    v-model="formData.password"
                    @keypress.enter="login"
                  />
                  <div v-if="$v.formData.password.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.password.required">
                      Field is required
                    </div>
                  </div>
                  <router-link
                    :to="{
                      name: 'ForgotPassword',
                      params: { siteName: clpSitePageSettings.siteName },
                    }"
                  >
                    <small class="text-right">Forgot password?</small>
                  </router-link>
                </base-input>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col text-center">
                <router-link
                  :to="{
                    name: 'SelfRegistration',
                    params: { siteName: clpSitePageSettings.siteName },
                  }"
                  tag="button"
                  class="btn btn-secondary"
                  v-if="clpSitePageSettings.allow_self_registration"
                >
                  Register
                </router-link>

                <b-button variant="primary" @click="login" :disabled="loading">
                  <span v-if="!loading">Log-in</span>
                  <span v-else
                    ><b-spinner small></b-spinner> Please wait ...</span
                  >
                </b-button>
              </div>
            </div>

            <div class="row" hidden>
              <div class="col text-center">
                <router-link
                  :to="{
                    name: 'AccountVerification',
                    params: { siteName: clpSitePageSettings.siteName },
                  }"
                >
                  <small><u>Signed up in store? Click here!</u></small>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HttpRequest from '../../controllers/httpRequest';
import secureStorage from '../../controllers/secureStorage';
import { required } from 'vuelidate/lib/validators';

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// const phoneNumberPattern = /^(?:\+63|0)9\d{9}$/;
const phoneNumberPattern = /^\+639\d{9}$/;

export default {
  name: 'MemberLogin',
  props: {
    clpSitePageSettings: Object,
  },
  data() {
    return {
      formData: {
        user_account: null,
        password: null,
      },
      siteName: null,
      loading: false,
      validUserAccount: true,
      validUserAccountMessage: '',
      countryCode: '+63'
    };
  },
  validations: {
    formData: {
      user_account: { required },
      password: { required },
    },
  },
  methods: {
    clear: function () {
      this.validUserAccount = true;
      this.validUserAccountMessage = '';
    },
    login: async function () {
      this.$v.formData.$touch();

      let input = this.formData.user_account;
      if (input.includes('@')) {
        if (!emailPattern.test(input)) {
          this.validUserAccount = false;
          this.validUserAccountMessage = 'Invalid Credentials';
        }
      } else {
          /* switch (input.length) {
          case 10:
            input = '+63' + input;
            break;
          case 11:
            if (input.charAt(0) === '0') {
              input = '+63' + input.slice(1);
            }
            break;
          case 12:
            if (input.charAt(0) === '6') {
              input = '+' + input;
            }
            break;
        } */
        const fullNumber = this.countryCode + input;

        if (!phoneNumberPattern.test(fullNumber)) {
          this.validUserAccount = false;
          this.validUserAccountMessage = 'Invalid mobile number';
          return;
        }

        input = fullNumber;
      }
      if (!this.$v.formData.$invalid) {
        this.loading = true;
        const { password } = this.formData;
        const res = await HttpRequest.postRequest(
          '/api/v2/clp_member_accounts/login',
          {
            account: {
              membership_program_id:
                this.clpSitePageSettings.membership_program_id,
              site_page_id: this.clpSitePageSettings.id,
              user_account: input,
              password: password,
            },
          }
        );

        if (res.access_token !== undefined && res.access_token !== null) {
          secureStorage.setItem('clpSitePageAccessToken', res.access_token);

          this.$notification.success({
            message: 'Success',
          });

          setTimeout(() => {
            console.log('router push');
            this.$router.push({
              name: 'Rewards',
              params: { siteName: this.clpSitePageSettings.siteName },
            });
          }, 1000);
        } else {
          if (res.error != undefined) {
            this.$notification.error({
              message: res.error,
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.',
            });
          }
        }

        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  padding: 2rem;
}

.card-body {
  padding: 2.5rem;
}

h2 {
  color: #003087; /* strong blue like in the image */
  font-weight: bold;
}

input,
input[type="password"] {
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 10px;
  font-size: 0.95rem;
}

.btn-secondary {
  background: #eee;
  color: #333;
  border-radius: 15px;
  font-weight: bold;
  padding: 8px 20px;
  margin-right: 10px;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.btn-secondary:hover {
  background-color: #ddd;
}

.btn-primary {
  background: #f4511e;
  border-radius: 15px;
  padding: 8px 20px;
  font-weight: bold;
  border: none;
  box-shadow: 0 4px 6px rgba(244, 81, 30, 0.3);
}

.btn-primary:disabled {
  background: #f8a07c;
}

.text-danger {
  font-size: 0.85rem;
  margin-top: 4px;
}
</style>

